module.exports = __webpack_public_path__ + "img/loader.272baf8c.svg";